// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../var/task/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".my-search-token[data-v-7d870d3c]{margin:2px;padding:2px 6px;display:inline-block;border:1px solid #ccc;border-radius:14px}.my-search-token .close[data-v-7d870d3c]{padding-left:2px;padding-right:2px}", ""]);
// Exports
module.exports = exports;
